import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Search, X } from 'lucide-react';
import './SearchInput.css';

export default function SearchInput({
    value = '',
    onChange,
    onSearch,
    placeholder = 'Search...',
    debounce = 300,
    clearable = true,
    loading = false,
    className = ''
}) {
    const [inputValue, setInputValue] = useState(value);
    const debounceRef = useRef(null);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);
        onChange?.(newValue);

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        if (debounce > 0) {
            debounceRef.current = setTimeout(() => {
                onSearch?.(newValue);
            }, debounce);
        } else {
            onSearch?.(newValue);
        }
    };

    const handleClear = () => {
        setInputValue('');
        onChange?.('');
        onSearch?.('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
            onSearch?.(inputValue);
        }
    };

    return (
        <div className={`search-input ${className}`}>
            <Search size={18} className="search-icon" />
            <input
                type="text"
                value={inputValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder={placeholder}
                className="search-field"
            />
            {loading && <span className="search-loading" />}
            {clearable && inputValue && !loading && (
                <button className="search-clear" onClick={handleClear}>
                    <X size={16} />
                </button>
            )}
        </div>
    );
}

SearchInput.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onSearch: PropTypes.func,
    placeholder: PropTypes.string,
    debounce: PropTypes.number,
    clearable: PropTypes.bool,
    loading: PropTypes.bool,
    className: PropTypes.string
};
